/**
 * Lifecycle of a Privatrechnung (ADR-0043): the GoBD-relevant document
 * transitions only. Whether the invoice went out is the `sentAt` delivery
 * fact; how far it is paid is the `PatientInvoiceSettlement`.
 */
export var PatientInvoiceStatus;
(function (PatientInvoiceStatus) {
    PatientInvoiceStatus["DRAFT"] = "draft";
    PatientInvoiceStatus["ISSUED"] = "issued";
    PatientInvoiceStatus["CANCELLED"] = "cancelled";
})(PatientInvoiceStatus || (PatientInvoiceStatus = {}));
//# sourceMappingURL=patient-invoice-status.enum.js.map